import { render, staticRenderFns } from "./NewsInfo.vue?vue&type=template&id=6b46d096&scoped=true&"
import script from "./NewsInfo.vue?vue&type=script&lang=js&"
export * from "./NewsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b46d096",
  null
  
)

export default component.exports